"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setLightShadow;
function setLightShadow(light) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (light.isDirectionalLight) {
    var _options$shadowMapSiz = options.shadowMapSize,
      shadowMapSize = _options$shadowMapSiz === void 0 ? 512 : _options$shadowMapSiz,
      _options$cameraProps = options.cameraProps,
      cameraProps = _options$cameraProps === void 0 ? {} : _options$cameraProps;
    light.castShadow = true;
    light.shadow.mapSize.width = shadowMapSize;
    light.shadow.mapSize.height = shadowMapSize;
    light.shadow.camera.top = d;
    light.shadow.camera.bottom = -d;
    light.shadow.camera.left = -d;
    light.shadow.camera.right = d;
    light.shadow.camera.near = 0.0001;
    light.shadow.camera.far = 2 * d + 0.0001;
    Object.assign(light.shadow.camera, cameraProps);
    light.shadow.camera.updateProjectionMatrix();
  }
}